import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const propTypes = {
    classes: PropTypes.object.isRequired,
    service: PropTypes.string.isRequired,
    forceHoveredEffect: PropTypes.bool
};

const servicesMap = {
    twitch: {
        icon: `https://s3.amazonaws.com/cdn.streamelements.com/assets/social-icons/twitch_white.svg`,
        text: 'CONNECT NOW',
        normalStyle: {
            backgroundImage: 'linear-gradient(257deg, #a23ac3, #6a45ad 99%)'
        },
        hoveredStyle: {
            backgroundImage: 'linear-gradient(257deg,#b36ec9, #997bce 99%)'
        }
    },
    dashboard: {
        icon: null,
        text: 'MY DASHBOARD',
        normalStyle: {
            background: '#ffa500'
        },
        hoveredStyle: {
            background: '#ffbb3f'
        }
    }
};

class ConnectButton extends React.Component {
    render() {
        const {classes, service, forceHoveredEffect} = this.props;

        const serviceData = servicesMap[service];

        const icon = serviceData.icon;
        const text = serviceData.text;
        const buttonServiceClass = classes[service]; // the class specific for the service
        const buttonHoverStyle = forceHoveredEffect ? serviceData.hoverEffects : ''; // should we force hover effect?

        const textClass = `${classes.buttonText} ${icon ? classes.buttonTextWithIcon : ''}`;

        return (
            <div className={`${classes.button} ${buttonServiceClass} ${buttonHoverStyle}`}>
                {icon &&
                <img src={icon} alt={service}/>
                }
                <span className={textClass}>{text}</span>
            </div>
        )
    }
}

const styles = theme => ({
    button: {
        borderRadius: '55px',
        transition: 'all 700ms',
        objectFit: 'contain',
        marginTop: ' 25px',
        marginBottom: '15px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px 25px',
        width: '80%',
        maxWidth: '300px',
    },
    buttonText: {
        color: 'white',
        letterSpacing: '2.4px'
    },
    buttonTextWithIcon: {
        paddingLeft: '10px'
    },
    twitch: Object.assign({}, servicesMap.twitch.normalStyle, {
        '&:hover': servicesMap.twitch.hoveredStyle
    }),
    dashboard: Object.assign({}, servicesMap.dashboard.normalStyle, {
        '&:hover': servicesMap.dashboard.hoveredStyle
    })
});

ConnectButton.propTypes = propTypes;

export default injectSheet(styles)(ConnectButton);



// WEBPACK FOOTER //
// ./src/app/components/banner/ConnectButton.js